export const handleWinCard = (k: any, arr: []) => {
  const winArr = arr.map((item) => item === "1");
  return winArr[k];
};

const handleHolded = (e: number, arr: any, func: any) => {
  arr[e] === 0 ? (arr[e] = 1) : (arr[e] = 0);
  func(arr);
};
const handleSelected = (e: number, arr: any, func: any) => {
  if (arr.includes(e)) {
    func((arr: any) => arr.filter((arr: any) => arr !== e));
  } else {
    func((arr: any) => [...arr, e]);
  }
};

export const handleHoldedCards = (
  i: number,
  holdedArr: any[],
  setHoldedArr: any[],
  selectedArr: any[],
  setSelectedArr: any
) => {
  handleHolded(i, holdedArr, setHoldedArr);
  handleSelected(i, selectedArr, setSelectedArr);
};

